<template>
  <nav class="c-menu">
    <div
      v-for="(items, group) in groups"
      :key="group"
      :class="['group', '-' + group]"
    >
      <c-title
        v-if="getTitle(group)"
        size="5"
        class="title"
      >
        {{ getTitle(group) }}
      </c-title>

      <div class="items">
        <c-menu-item
          class="item"
          v-for="item in items"
          :key="item.path"
          :item="item"
          :group="group"
          :is-nuxt="isNuxt"
          @click="$emit('click-item', item)"
        />
      </div>
    </div>
  </nav>
</template>

<script>
import CMenuItem from './CMenuItem'

export default {
  components: { CMenuItem },
  props: {
    groupOptions: {
      type: Object,
      default: () => ({})
    },
    itemsMenu: {
      type: Array,
      default: () => []
    },
    isNuxt: Boolean
  },
  computed: {
    groups () {
      const groups = this.itemsMenu.reduce((groups, item) => {
        const group = item.group || 'primary'
        groups[group] = [ ...groups[group] || [], item ]
        return groups
      }, Object.create(null))
      return groups
    }
  },
  methods: {
    getTitle (group) {
      const options = this.groupOptions[group]
      const title = options && options.title
      return title
    }
  }
}
</script>

<style lang="scss">
@import '~@styles/convenia-components/reference.scss';

$c-menu-background-color: transparent !default;
$c-menu-padding: outer-base(1) !default;

.c-menu {
  flex: 0 100%;
  width: 100%;
  background-color: $c-menu-background-color;
  padding: $c-menu-padding;
  box-sizing: border-box;

  & > .group {
    @extend %c-menu-group;

    & + .group { border-top: 1px solid #e8e9f0; }

    & > .title {
      text-transform: uppercase;
      margin: 0 0 inner-base() 0;
    }
  }
}

%c-menu-group {
  position: relative;
  padding-top: inner-base();
  padding-bottom: inner-base();

  & > .items { @extend %c-menu-items; }
}

%c-menu-items {
  & > .item {
    display: block;
    margin-top: inner-base();
    margin-bottom: inner-base();

    &:first-of-type { margin-top: 0; }
    &:last-of-type { margin-bottom: 0; }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/convenia-components/CMenu.vue